import Query from "../utils/Query";

export default class SearchService {

	static query(query, lang, log = true) {
		return Query.get('/custom/search/' + lang + '?q=' + query.trim().split(' ').join('+') + '&log=' + (log ? '1' : '0'));
	}

	static getLatestSearchTerms(userId) {
		return Query.get('items/search_query?filter[created_by]=' + userId + '&sort=-id&limit=10');
	}
}
